@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.carousel {
    --slides-visible: 3;
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    @media ($below-mobile) {
        --slides-visible: 1.05;

        width: 100vw;
        margin-left: calc(var(--labui-container-margin) * -1);
    }

    > * {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: var(--width);
        gap: var(--gutter-width);

        @media ($below-mobile) {
            display: block;
            padding-inline: var(--labui-container-margin);

            // honestly one of the dumbest CSS hacks I've pulled in awhile,
            // but it makes the last card line up right
            &::after {
                content: " ";
                display: inline-block;
                width: 200px;
            }

            > * {
                margin-inline: var(--spacer-4);
                scroll-snap-align: center;
            }
        }
    }
}

.card {
    text-align: center;
}

.image {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    margin-bottom: var(--spacer-24);
}

.title {
    margin-bottom: var(--spacer-24);
    font: var(--font-h-24);
}

.pillHeading {
    composes: fontEyebrow14 from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-12);
}

.list {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-8);
}

.listItem {
    padding: var(--spacer-8) var(--spacer-16);
    background-color: var(--true-white);
    border-radius: 999px;
    color: var(--navy);
    font: var(--font-s-16);
}
